import "./App.css";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./HeaderandFooter/Header";
import Home from "./Components/Home";
import About from "./Components/About";
import Whymcm from "./Components/Whymcm";
import Infrastructure from "./Components/Infrastructure";
import Footer from "./HeaderandFooter/Footer";
import InternationalStudents from "./Components/InternationalStudents";
import Courses from "./Components/Courses";
import Howcanispeak from "./Components/Howcanispeak";
import StudyEnglishfor from "./Components/StudyEnglishfor";
import StudyinEnglish from "./Components/StudyinEnglish";
import Administration from "./Components/Administration";
import Whymysore from "./Components/Whymysore";
import Mysoretourisim from "./Components/Mysoretourisim";
import Contact from "./Components/Contact";
import Team from "./Components/Team";

function App() {
  const [isTranslateLoaded, setIsTranslateLoaded] = useState(false);
  const [translateError, setTranslateError] = useState(null);

  // Function to initialize Google Translate
  const initializeGoogleTranslate = () => {
    try {
      if (window.google && window.google.translate && window.google.translate.TranslateElement) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'en',
            includedLanguages: 'en,es,fr,de,zh-CN,ja,ko,ar,hi,kn,ta',
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false
          },
          'google_translate_element'
        );
        setIsTranslateLoaded(true);
        setTranslateError(null);
      } else {
        console.warn('Google Translate API not available yet');
      }
    } catch (error) {
      console.error('Error initializing Google Translate:', error);
      setTranslateError('Failed to load translator');
    }
  };

  // Load Google Translate script
  useEffect(() => {
    // Check if script is already loaded
    const existingScript = document.getElementById('google-translate-script');
    
    if (existingScript) {
      // If script exists but Google API isn't loaded yet
      if (!window.google) {
        // Try to initialize after a delay
        const timer = setTimeout(initializeGoogleTranslate, 1000);
        return () => clearTimeout(timer);
      } else {
        initializeGoogleTranslate();
      }
      return;
    }

    // Create and add the script
    const script = document.createElement('script');
    script.id = 'google-translate-script';
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    script.defer = true;
    
    // Handle script load error
    script.onerror = () => {
      console.error('Failed to load Google Translate script');
      setTranslateError('Unable to load translator');
    };
    
    // Define the callback function
    window.googleTranslateElementInit = () => {
      console.log('Google Translate script loaded');
      initializeGoogleTranslate();
    };
    
    document.head.appendChild(script);

    // Cleanup
    return () => {
      // Don't remove the script as Google Translate needs it
      delete window.googleTranslateElementInit;
    };
  }, []);

  return (
    <BrowserRouter>
      <Header />
      
      {/* Google Translate Widget with error handling */}
      {translateError ? (
        <div style={{
          position: 'fixed',
          top: '80px',
          right: '20px',
          zIndex: 9999,
          backgroundColor: '#ffebee',
          color: '#c62828',
          padding: '10px',
          borderRadius: '5px',
          fontSize: '12px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          {translateError}
        </div>
      ) : (
        <div id="google_translate_element" style={{ 
          position: 'fixed', 
          top: '80px', 
          right: '20px', 
          zIndex: 9999,
          backgroundColor: 'white',
          padding: '5px',
          borderRadius: '5px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          visibility: isTranslateLoaded ? 'visible' : 'hidden'
        }}></div>
      )}
      
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/Whymcm" element={<Whymcm />} />
          <Route path="/Infrastructure" element={<Infrastructure />} />
          <Route
            path="/InternationalStudents"
            element={<InternationalStudents />}
          />
          <Route path="/Courses" element={<Courses />} />
          <Route path="/Howcanispeak" element={<Howcanispeak />} />
          <Route path="/StudyEnglishfor" element={<StudyEnglishfor />} />
          <Route path="/StudyinEnglish" element={<StudyinEnglish />} />
          <Route path="/administration" element={<Administration />} />
          <Route path="/Whymysore" element={<Whymysore />} />
          <Route path="/Mysoretourisim" element={<Mysoretourisim />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Team" element={<Team />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;